import { render, staticRenderFns } from "./ReservationBottomBar.vue?vue&type=template&id=d64524a6&scoped=true&"
import script from "./ReservationBottomBar.vue?vue&type=script&lang=js&"
export * from "./ReservationBottomBar.vue?vue&type=script&lang=js&"
import style0 from "./ReservationBottomBar.vue?vue&type=style&index=0&id=d64524a6&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d64524a6",
  null
  
)

export default component.exports